module.exports = __webpack_public_path__ + "static/media/G1-15-Alisha-Kamber-cod35.f4f0811a.png";